module.exports = __webpack_public_path__ + "img/38.c7c29ee7.svg";